module.exports = __webpack_public_path__ + "static/media/image_12.59738cdb.png";